import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import QuickLinksBar from './components/QuickLinksBar';
import Landing from './pages/Landing';
import LandingNew from './pages/LandingNew';
import Welcome from './pages/onboarding/Welcome';
import ParentResourceCenter from './pages/resources/ParentResourceCenter';
import Jobs from './pages/Jobs';
import DeafHardOfHearingJobs from './pages/jobs/DeafHardOfHearingJobs';
import PopulationLandingPage from './pages/jobs/PopulationLandingPage';
import JobLandingPage from './pages/jobs/JobLandingPage';
import JobDetail from './pages/JobDetail';
import { Login, Register, AuthCallback } from './pages/Auth';
import JobSeekerDashboard from './pages/JobSeekerDashboard';
import JobPreferences from './pages/JobPreferences';
import EmployerDashboard from './pages/EmployerDashboard';
import PostJob from './pages/PostJob';
import AdminDashboard from './pages/AdminDashboard';
import FeaturedJobUpgrade from './pages/employer/FeaturedJobUpgrade';
import AdminFeaturedJobs from './pages/AdminFeaturedJobs';
import MyFeatured from './pages/featured/MyFeatured';
import CardReturn from './pages/featured/CardReturn';
import AdminFeatured from './pages/admin/AdminFeatured';
import AdminFeaturedRollout from './pages/admin/AdminFeaturedRollout';
import { SubscriptionPlans, SubscriptionSuccess } from './pages/Subscription';
import Policies from './pages/Policies';
import CandidateBrowse from './pages/CandidateBrowse';
import { EmployerReviews } from './pages/Reviews';
import Messages from './pages/Messages';
import { EmployersList, EmployerProfile } from './pages/EmployerPublicProfile';
import ContactUs from './pages/ContactUs';
import ForEmployers from './pages/ForEmployers';
import PrivatePracticeDirectory from './pages/privatepractice/PrivatePracticeDirectory';
import ListYourPractice from './pages/privatepractice/ListYourPractice';
import MyInasw from './pages/MyInasw';
import CandidateInvitations from './pages/CandidateInvitations';
import About from './pages/About';
import TermsPolicies from './pages/TermsPolicies';
import PrivacyPolicy from './pages/PrivacyPolicy';
import EmployerFAQ from './pages/EmployerFAQ';
import Resources from './pages/Resources';
import Locations from './pages/Locations';
import Blog from './pages/Blog';
import CentralTexasSocialWorkJobs from './pages/CentralTexasSocialWorkJobs';
import { 
  HospitalSocialWorkerJobs, 
  SchoolSocialWorkerJobs, 
  HospiceSocialWorkerJobs,
  ClinicalSocialWorkerJobs,
  MedicalSocialWorkerJobs,
  CommunitySocialWorkerJobs,
  TexasSocialWorkerJobs,
  CaliforniaSocialWorkerJobs,
  FloridaSocialWorkerJobs,
  NewYorkSocialWorkerJobs,
  MichiganSocialWorkerJobs,
  NevadaSocialWorkerJobs,
  BehavioralHealthSocialWorkerJobs,
  ForensicSocialWorkerJobs
} from './pages/jobs';
import BlogPostPage from './pages/blog/BlogPostPage';
import SupervisorDirectory from './pages/marketplace/SupervisorDirectory';
import SupervisorProfile from './pages/marketplace/SupervisorProfile';
import InternshipDirectory from './pages/marketplace/InternshipDirectory';
import InternshipDetail from './pages/marketplace/InternshipDetail';
import BecomeSupervisor from './pages/marketplace/BecomeSupervisor';
import PostInternship from './pages/marketplace/PostInternship';
import PostFreeInternship from './pages/marketplace/PostFreeInternship';import MarketplaceSuccess from './pages/marketplace/MarketplaceSuccess';
import SupervisorDashboard from './pages/marketplace/SupervisorDashboard';
import StateSupervisors from './pages/marketplace/StateSupervisors';
import StateInternships from './pages/marketplace/StateInternships';
import InternshipPortal from './pages/portal/InternshipPortal';
import InternshipMembership from './pages/portal/InternshipMembership';
import LegalFormsDatabase from './pages/legal/LegalFormsDatabase';
import LegalFormState from './pages/legal/LegalFormState';
import LegalFormsAdmin from './pages/legal/LegalFormsAdmin';
import MyLegalForms from './pages/legal/MyLegalForms';
import InternshipDashboard from './pages/portal/InternshipDashboard';
import SignHours from './pages/portal/SignHours';
import ResourceDirectory, { ResourceDirectoryByPath } from './pages/resources/ResourceDirectory';
import ResourceDetail from './pages/resources/ResourceDetail';
import ResourceCategoryPage from './pages/resources/ResourceCategoryPage';
import ResourcePacket from './pages/resources/ResourcePacket';
import { ResourcePacketProvider } from './context/ResourcePacketContext';
import MyReferralFolders from './pages/resources/MyReferralFolders';
import AdminResources from './pages/admin/AdminResources';
import AdminMarketing from './pages/admin/AdminMarketing';
import AdminCoverage from './pages/admin/AdminCoverage';
import AskSocialWorker from './pages/community/AskSocialWorker';
import CommunityBrowse from './pages/community/CommunityBrowse';
import CommunityQuestion from './pages/community/CommunityQuestion';
import AskQuestion from './pages/community/AskQuestion';
import MyCommunityActivity from './pages/community/MyCommunityActivity';
import AdminCommunity from './pages/admin/AdminCommunity';
import LicenseCenter from './pages/license/LicenseCenter';
import StateLicense from './pages/license/StateLicense';
import MyLicenseReminders from './pages/license/MyLicenseReminders';
import BehavioralHealthDirectory from './pages/behavioral_health/BehavioralHealthDirectory';
import StateJobsPage from './pages/jobs/StateJobsPage';
import StateJobsHub from './pages/jobs/StateJobsHub';
import BehavioralHealthAdmin from './pages/admin/BehavioralHealthAdmin';
import MyLibrary from './pages/library/MyLibrary';
import SocialWorkFormsDirectory from './pages/social_work_forms/SocialWorkFormsDirectory';
import SocialWorkFormsAdmin from './pages/admin/SocialWorkFormsAdmin';
import { API_URL } from './lib/utils';
import './App.css';

// Site Visit Tracker Component
const getVisitorId = () => {
  try {
    let v = localStorage.getItem('inasw_vid');
    if (!v) { v = 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('inasw_vid', v); }
    return v;
  } catch { return null; }
};
const getSessionId = () => {
  try {
    let s = sessionStorage.getItem('inasw_sid');
    if (!s) { s = 's_' + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('inasw_sid', s); }
    return s;
  } catch { return null; }
};
const getUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const grab = (k) => p.get(k) || p.get(k.replace('utm_', '')) || undefined;
    let utm = { utm_source: grab('utm_source'), utm_medium: grab('utm_medium'), utm_campaign: grab('utm_campaign') };
    // persist first-touch UTM for the session so later pageviews keep attribution
    if (utm.utm_source) sessionStorage.setItem('inasw_utm', JSON.stringify(utm));
    else { const saved = sessionStorage.getItem('inasw_utm'); if (saved) utm = JSON.parse(saved); }
    return utm;
  } catch { return {}; }
};

const SiteVisitTracker = () => {
  const location = useLocation();
  useEffect(() => {
    axios.post(`${API_URL}/track-visit`, {
      path: location.pathname,
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      ...getUtm(),
    }).catch(() => {});
  }, [location.pathname]);
  return null;
};

// Protected route wrapper
const ProtectedRoute = ({ children, allowedTypes }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // If passed from AuthCallback, skip auth check
  if (location.state?.user) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (allowedTypes) {
    const roles = user?.roles || [];
    const permitted = allowedTypes.includes(user?.user_type) || allowedTypes.some((t) => roles.includes(t));
    if (!permitted) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

// App Router with session_id detection
const AppRouter = () => {
  const location = useLocation();

  // Check URL fragment for session_id (Google OAuth callback) - synchronous check
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <SiteVisitTracker />
      <ScrollToTop />
      <Navbar />
      <QuickLinksBar />
      <main className="min-h-screen">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingNew />} />
          <Route path="/classic-home" element={<Landing />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/deaf-hard-of-hearing-social-work-jobs" element={<DeafHardOfHearingJobs />} />
          <Route path="/veterans-social-work-jobs" element={<PopulationLandingPage populationKey="veterans" />} />
          <Route path="/autism-idd-social-work-jobs" element={<PopulationLandingPage populationKey="autism-idd" />} />
          <Route path="/older-adults-social-work-jobs" element={<PopulationLandingPage populationKey="older-adults" />} />
          {/* SEO job-keyword & job-board comparison landing pages */}
          <Route path="/social-work-job-boards" element={<JobLandingPage landingKey="social-work-job-boards" />} />
          <Route path="/social-work-jobs" element={<JobLandingPage landingKey="social-work-jobs" />} />
          <Route path="/social-work-jobs-by-state" element={<StateJobsHub />} />
          <Route path="/mental-health-social-worker-jobs" element={<JobLandingPage landingKey="mental-health-social-worker-jobs" />} />
          <Route path="/dialysis-social-worker-jobs" element={<JobLandingPage landingKey="dialysis-social-worker-jobs" />} />
          <Route path="/case-management-social-worker-jobs" element={<JobLandingPage landingKey="case-management-social-worker-jobs" />} />
          <Route path="/correctional-social-worker-jobs" element={<JobLandingPage landingKey="correctional-social-worker-jobs" />} />
          <Route path="/psychiatric-social-worker-jobs" element={<JobLandingPage landingKey="psychiatric-social-worker-jobs" />} />
          <Route path="/lmsw-jobs" element={<JobLandingPage landingKey="lmsw-jobs" />} />
          <Route path="/lcsw-jobs" element={<JobLandingPage landingKey="lcsw-jobs" />} />
          <Route path="/lbsw-jobs" element={<JobLandingPage landingKey="lbsw-jobs" />} />
          <Route path="/remote-social-work-jobs" element={<JobLandingPage landingKey="remote-social-work-jobs" />} />
          <Route path="/medical-social-worker-jobs" element={<JobLandingPage landingKey="medical-social-worker-jobs" />} />
          <Route path="/hospice-social-worker-jobs" element={<JobLandingPage landingKey="hospice-social-worker-jobs" />} />
          <Route path="/school-social-worker-jobs" element={<JobLandingPage landingKey="school-social-worker-jobs" />} />
          <Route path="/behavioral-health-social-worker-jobs" element={<JobLandingPage landingKey="behavioral-health-social-worker-jobs" />} />
          <Route path="/prn-social-worker-jobs" element={<JobLandingPage landingKey="prn-social-worker-jobs" />} />
          <Route path="/clinical-social-worker-jobs" element={<JobLandingPage landingKey="clinical-social-worker-jobs" />} />
          <Route path="/indeed-social-work-jobs" element={<JobLandingPage landingKey="indeed-social-work-jobs" />} />
          <Route path="/indeed-lmsw-jobs" element={<JobLandingPage landingKey="indeed-lmsw-jobs" />} />
          <Route path="/indeed-lcsw-jobs" element={<JobLandingPage landingKey="indeed-lcsw-jobs" />} />
          <Route path="/indeed-remote-social-work-jobs" element={<JobLandingPage landingKey="indeed-remote-social-work-jobs" />} />
          <Route path="/ziprecruiter-social-work-jobs" element={<JobLandingPage landingKey="ziprecruiter-social-work-jobs" />} />
          <Route path="/ziprecruiter-lmsw-jobs" element={<JobLandingPage landingKey="ziprecruiter-lmsw-jobs" />} />
          <Route path="/ziprecruiter-lcsw-jobs" element={<JobLandingPage landingKey="ziprecruiter-lcsw-jobs" />} />
          <Route path="/ziprecruiter-remote-social-work-jobs" element={<JobLandingPage landingKey="ziprecruiter-remote-social-work-jobs" />} />
          <Route path="/jobs/:jobId" element={<JobDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-hours/:token" element={<SignHours />} />
          <Route path="/register" element={<Register />} />
          <Route path="/private-practice" element={<PrivatePracticeDirectory />} />
          <Route
            path="/my-inasw"
            element={
              <ProtectedRoute>
                <MyInasw />
              </ProtectedRoute>
            }
          />
          <Route
            path="/private-practice/list"
            element={
              <ProtectedRoute>
                <ListYourPractice />
              </ProtectedRoute>
            }
          />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/employer/featured-job" element={<ProtectedRoute><FeaturedJobUpgrade /></ProtectedRoute>} />
          <Route path="/admin/featured-jobs" element={<ProtectedRoute allowedTypes={['admin']}><AdminFeaturedJobs /></ProtectedRoute>} />
          <Route path="/admin/featured" element={<ProtectedRoute allowedTypes={['admin']}><AdminFeatured /></ProtectedRoute>} />
          <Route path="/admin/featured/rollout" element={<ProtectedRoute allowedTypes={['admin']}><AdminFeaturedRollout /></ProtectedRoute>} />
          <Route path="/my-featured" element={<ProtectedRoute><MyFeatured /></ProtectedRoute>} />
          <Route path="/featured/card-saved" element={<ProtectedRoute><CardReturn /></ProtectedRoute>} />
          <Route path="/featured/card-cancel" element={<ProtectedRoute><CardReturn /></ProtectedRoute>} />
          <Route
            path="/welcome"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent-resource-center"
            element={<ParentResourceCenter />}
          />

          {/* Job Seeker routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedTypes={['job_seeker']}>
                <JobSeekerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/profile"
            element={
              <ProtectedRoute allowedTypes={['job_seeker']}>
                <JobSeekerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-preferences"
            element={
              <ProtectedRoute allowedTypes={['job_seeker']}>
                <JobPreferences />
              </ProtectedRoute>
            }
          />

          {/* Employer routes */}
          <Route
            path="/employer/dashboard"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <EmployerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employer/post-job"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <PostJob />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employer/edit-job/:jobId"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <PostJob />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employer/subscription"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <SubscriptionPlans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employer/subscription/success"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <SubscriptionSuccess />
              </ProtectedRoute>
            }
          />

          {/* Public Policies page */}
          <Route path="/policies" element={<Policies />} />
          
          {/* Contact Us page */}
          <Route path="/contact" element={<ContactUs />} />

          {/* Employer candidate browsing */}
          <Route
            path="/employer/candidates"
            element={
              <ProtectedRoute allowedTypes={['employer', 'admin']}>
                <CandidateBrowse />
              </ProtectedRoute>
            }
          />

          {/* Reviews */}
          <Route path="/reviews/employer/:employerId" element={<EmployerReviews />} />

          {/* Messages */}
          <Route
            path="/messages"
            element={
              <ProtectedRoute allowedTypes={['job_seeker', 'employer', 'admin']}>
                <Messages />
              </ProtectedRoute>
            }
          />

          {/* For Employers landing page */}
          <Route path="/for-employers" element={<ForEmployers />} />
          
          {/* About page */}
          <Route path="/about" element={<About />} />
          
          {/* Employer Public Profiles */}
          <Route path="/employers" element={<EmployersList />} />
          <Route path="/employers/:employerId" element={<EmployerProfile />} />

          {/* Terms & Policies */}
          <Route path="/terms" element={<TermsPolicies />} />
          <Route path="/terms-policies" element={<TermsPolicies />} />
          
          {/* Privacy Policy */}
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Employer FAQ */}
          <Route path="/employer-faq" element={<EmployerFAQ />} />
          <Route path="/license-verification-faq" element={<EmployerFAQ />} />

          {/* Resources */}
          <Route path="/resources" element={<Resources />} />

          {/* Locations */}
          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/:state" element={<Locations />} />
          <Route path="/social-work-jobs/:state" element={<StateJobsPage />} />

          {/* Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/central-texas-social-work-jobs" element={<CentralTexasSocialWorkJobs />} />

          {/* Job Category SEO Pages */}
          <Route path="/hospital-social-worker-jobs" element={<HospitalSocialWorkerJobs />} />
          <Route path="/school-social-worker-jobs" element={<SchoolSocialWorkerJobs />} />
          <Route path="/hospice-social-worker-jobs" element={<HospiceSocialWorkerJobs />} />
          <Route path="/clinical-social-worker-jobs" element={<ClinicalSocialWorkerJobs />} />
          <Route path="/medical-social-worker-jobs" element={<MedicalSocialWorkerJobs />} />
          <Route path="/community-social-worker-jobs" element={<CommunitySocialWorkerJobs />} />
          <Route path="/behavioral-health-social-worker-jobs" element={<BehavioralHealthSocialWorkerJobs />} />
          <Route path="/forensic-social-worker-jobs" element={<ForensicSocialWorkerJobs />} />
          {/* State SEO Pages */}
          <Route path="/texas-social-worker-jobs" element={<TexasSocialWorkerJobs />} />
          <Route path="/california-social-worker-jobs" element={<CaliforniaSocialWorkerJobs />} />
          <Route path="/florida-social-worker-jobs" element={<FloridaSocialWorkerJobs />} />
          <Route path="/new-york-social-worker-jobs" element={<NewYorkSocialWorkerJobs />} />
          <Route path="/michigan-social-worker-jobs" element={<MichiganSocialWorkerJobs />} />
          <Route path="/nevada-social-worker-jobs" element={<NevadaSocialWorkerJobs />} />

          {/* Supervisor & Internship Marketplace */}
          <Route path="/find-a-supervisor" element={<SupervisorDirectory />} />
          <Route path="/supervisors/:userId" element={<SupervisorProfile />} />
          <Route path="/internships" element={<InternshipDirectory />} />
          <Route path="/internships/:internshipId" element={<InternshipDetail />} />
          <Route path="/become-a-supervisor" element={<BecomeSupervisor />} />
          <Route path="/post-an-internship" element={<PostInternship />} />
          <Route path="/post-free-internship" element={<PostFreeInternship />} />
          <Route path="/marketplace/success" element={<MarketplaceSuccess />} />
          {/* Community Resource Directory */}
          <Route path="/community/resources" element={<ResourceDirectory />} />
          <Route
            path="/community/resources/packet"
            element={
              <ProtectedRoute>
                <ResourcePacket />
              </ProtectedRoute>
            }
          />
          <Route path="/community/resources/:categorySlug" element={<ResourceCategoryPage />} />
          {/* Clean, shareable community resource URLs */}
          <Route path="/community-resources" element={<ResourceDirectory />} />
          <Route path="/community-resources/resource/:slug" element={<ResourceDetail />} />
          <Route path="/community-resources/:seg1" element={<ResourceDirectoryByPath />} />
          <Route path="/community-resources/:seg1/:seg2" element={<ResourceDirectoryByPath />} />
          {/* Ask a Social Worker — moderated community */}
          <Route path="/community/ask-a-social-worker" element={<AskSocialWorker />} />
          <Route path="/community/questions" element={<CommunityBrowse />} />
          <Route path="/community/questions/:questionId" element={<CommunityQuestion />} />
          <Route path="/community/ask" element={<AskQuestion />} />
          <Route path="/community/my-activity" element={<MyCommunityActivity />} />
          <Route
            path="/admin/community"
            element={
              <ProtectedRoute allowedTypes={['admin']}>
                <AdminCommunity />
              </ProtectedRoute>
            }
          />
          {/* National License & Renewal Center */}
          <Route path="/license-renewal-center" element={<LicenseCenter />} />
          <Route path="/license-renewal-center/:state" element={<StateLicense />} />
          {/* National Advance Directives & Legal Forms Database */}
          <Route path="/advance-directives" element={<LegalFormsDatabase />} />
          <Route path="/advance-directives/:slug" element={<LegalFormState />} />
          <Route path="/my-legal-forms" element={<MyLegalForms />} />
          <Route path="/admin/legal-forms" element={<LegalFormsAdmin />} />
          {/* National Behavioral Health Forms & Assessments Directory */}
          <Route path="/behavioral-health-directory" element={<BehavioralHealthDirectory />} />
          <Route path="/admin/behavioral-health" element={<ProtectedRoute><BehavioralHealthAdmin /></ProtectedRoute>} />
          {/* Social Work Forms Center */}
          <Route path="/social-work-forms" element={<SocialWorkFormsDirectory />} />
          <Route path="/admin/social-work-forms" element={<ProtectedRoute><SocialWorkFormsAdmin /></ProtectedRoute>} />
          {/* My INASW Library (free member hub) */}
          <Route path="/my-library" element={<ProtectedRoute><MyLibrary /></ProtectedRoute>} />
          <Route path="/my-invitations" element={<ProtectedRoute allowedTypes={['job_seeker']}><CandidateInvitations /></ProtectedRoute>} />
          <Route
            path="/my-license-reminders"
            element={
              <ProtectedRoute>
                <MyLicenseReminders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/resources"
            element={
              <ProtectedRoute allowedTypes={['admin']}>
                <AdminResources />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing"
            element={
              <ProtectedRoute allowedTypes={['admin']}>
                <AdminMarketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/coverage"
            element={
              <ProtectedRoute allowedTypes={['admin']}>
                <AdminCoverage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-referral-folders"
            element={
              <ProtectedRoute>
                <MyReferralFolders />
              </ProtectedRoute>
            }
          />
          {/* Internship Management Portal (Phase 1 — private student tracker) */}
          <Route path="/internship-portal" element={<InternshipPortal />} />
          <Route path="/internship-portal/membership" element={<InternshipMembership />} />
          <Route path="/internship-portal/membership/success" element={<InternshipMembership />} />
          <Route
            path="/my-internship-dashboard"
            element={
              <ProtectedRoute>
                <InternshipDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/track-my-hours"
            element={
              <ProtectedRoute>
                <InternshipDashboard defaultTab="hours" />
              </ProtectedRoute>
            }
          />
          {/* Per-state SEO landing pages */}
          <Route path="/:state/clinical-supervisors" element={<StateSupervisors />} />
          <Route path="/:state/msw-internships" element={<StateInternships />} />
          <Route
            path="/supervisor/dashboard"
            element={
              <ProtectedRoute allowedTypes={['supervisor', 'admin']}>
                <SupervisorDashboard />
              </ProtectedRoute>
            }
          />

          {/* Admin routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedTypes={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <ResourcePacketProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </ResourcePacketProvider>
    </AuthProvider>
  );
}

export default App;
